import { Badge } from "@stocks/ui";

import { needsReplenishment } from "../lib/quantity";

/** 가용 수량 < 안전재고 이면 '보충 필요', 아니면 '정상'. */
export const ReplenishBadge = ({
  available,
  safetyStock,
}: {
  available: string;
  safetyStock: string;
}) =>
  needsReplenishment(available, safetyStock) ? (
    <Badge variant='destructive'>보충 필요</Badge>
  ) : (
    <Badge variant='outline'>정상</Badge>
  );
